import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ResultWells, WellPath } from '../interfaces/well';
import { BaseService } from './base.service.class';
import { NotificationService } from './notification.service';
import { UserService } from './user.service';
import { environment } from 'src/environments/environment';
import { Casing } from '../interfaces/casing-liner';

@Injectable({
  providedIn: 'root',
})
export class WellService extends BaseService {
  private wellsUrl = `${environment.urlBackend}/dhoapi/wells`;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    protected notificationService: NotificationService
  ) {
    super(notificationService);
  }

  getSearchWells(
    search: string,
    limit: number,
    offset: number
  ): Observable<ResultWells> {
    let url: string;
    const ug = this.userService.getManagementUnits();
    if (search == '') {
      url = `${this.wellsUrl}/?limit=${limit}&offset=${offset}`;
    } else {
      url = `${this.wellsUrl}/?search=${search}&limit=${limit}&offset=${offset}`;
    }

    if (ug != '') {
      url = url + `&managementUnit=${ug}`;
    }
    return this.http.get<ResultWells>(url).pipe(
      tap((_) => {
        console.log('fetched searchWells');
      }),
      catchError(
        this.handleError<ResultWells>('getWells', {
          wells: [],
          totalWells: 0,
        })
      )
    );
  }

  getWellPath(wellUwi: string): Observable<WellPath> {
    const url = `${this.wellsUrl}/path?wellUwi=${wellUwi}`;

    return this.http.get<WellPath>(url).pipe(
      tap((_) => {
        console.log('fetched well path');
      }),
      catchError(
        this.handleError<WellPath>('getWellPath', {
          md: [],
          inc: [],
          azi: [],
          tvd: [],
          ew: [],
          ns: [],
          dogleg: [],
          sequence: [],
        })
      )
    );
  }

  getCasings(wellName: string): Observable<Casing[]> {
    const url = `${this.wellsUrl}/${wellName}/casings`;
    return this.http.get<Casing[]>(url).pipe(
      tap((wt: Casing[]) =>
        console.log(`WellName ${wellName} - Casings fetched`)
      ),
      catchError(this.handleError<Casing[]>(`getCasings`))
    );
  }
}
